
export const easterCamp = {
  title: "Campamento de Semana Santa",
  subtitle: "Una experiencia única de aprendizaje y diversión en contacto con la naturaleza",
  gallery: {
    title: "Galería",
    caption: "Momentos de nuestros campamentos de Semana Santa",
    images: [
      { src: "/lovable-uploads/patio-futbol-pradera.png", alt: "Niños explorando la naturaleza" },
      { src: "/lovable-uploads/patio-carpinteria-cana.png", alt: "Actividades al aire libre" },
      { src: "/lovable-uploads/huerta-charco-barro.png", alt: "Materiales Montessori" }
    ]
  },
  description: {
    title: "Descripción del Campamento",
    content1: "Nuestro campamento de Semana Santa ofrece una variedad de actividades que incluyen talleres de cocina, experimentos científicos, juegos en la naturaleza y arte creativo con Voadoras. Diseñaremos actividades detalladas una vez que sepamos el número de niños que asistirán, pero enviaremos ejemplos de actividades y talleres en los próximos días.",
    content2: "Nuestros profesores tienen muchas ideas de cocina y actividades creativas planeadas. Utilizaremos materiales disponibles en Gándara, creando un ambiente que fomente la exploración, la creatividad y la diversión."
  },
  activities: {
    title: "Actividades y Talleres",
    list: [
      "Talleres de cocina adaptados para niños",
      "Experimentos científicos divertidos y educativos",
      "Juegos en la naturaleza y exploración al aire libre",
      "Arte creativo con Voadoras",
      "Proyectos de arte con arcilla con texturas de objetos cotidianos, elementos naturales y materiales reciclados",
      "Proyectos de arte inspirados en la artista Louise Nevelson, creando esculturas con materiales reciclados"
    ]
  },
  spaces: {
    title: "Espacios de Aprendizaje",
    intro: "Crearemos diferentes rincones de actividad en el espacio de oficina:",
    list: [
      {
        title: "RINCÓN DE LECTURA",
        description: "Un espacio acogedor con alfombra, cojines y una estantería con cuentos."
      },
      {
        title: "ÁREA DE RELAJACIÓN",
        description: "Un tipi, alfombra, peluches, colchón y telas. Los espacios 1 y 2 estarán juntos."
      },
      {
        title: "JUEGO SIMBÓLICO",
        description: "Cocina, mesa, vajilla y elementos para el juego imaginativo."
      },
      {
        title: "CONSTRUCCIÓN Y MINI-MUNDOS",
        description: "Todos los materiales de construcción (magnéticos, piezas de madera...), recipientes con piezas sueltas."
      },
      {
        title: "RINCÓN ARTÍSTICO",
        description: "Una mesa pequeña de Infantil y una pequeña estantería con materiales de arte."
      }
    ]
  },
  schedule: {
    title: "Horario Diario",
    list: [
      "Llegada y juego libre",
      "Asamblea y presentación del día",
      "Taller",
      "Merienda",
      "Juego libre",
      "Taller",
      "Asamblea final y relajación"
    ]
  },
  prices: {
    title: "Precios",
    headers: {
      fullCamp: "4 Días",
      singleDay: "Día Suelto",
      earlyBird: "Madrugadores",
      lunch: "Comedor"
    },
    students: "Alumnos Gándara",
    external: "Alumnos Externos"
  },
  contact: {
    title: "Contacto",
    button: "Reservar Visita"
  }
};

export const christmasCamp = {
  title: "Campamento Navideño",
  subtitle: "Un campamento donde el juego libre, la curiosidad y la creatividad guían cada día, con acompañamiento cercano y respetuoso",
  gallery: {
    title: "Galería",
    caption: "Momentos mágicos de nuestro campamento navideño",
    images: [
      { src: "/lovable-uploads/christmas-camp-poster.jpg", alt: "Póster del Campamento Navideño" }
    ]
  },
  description: {
    title: "Descripción del Campamento",
    content1: "Celebra las fiestas con nosotros en un ambiente mágico donde los niños podrán disfrutar de actividades creativas, talleres navideños y momentos de juego libre.",
    content2: "Nuestro equipo de acompañantes crea un espacio seguro y respetuoso donde cada niño puede explorar, crear y divertirse a su ritmo."
  },
  activities: {
    title: "Actividades",
    list: [
      "Talleres navideños creativos",
      "Cocina saludable y recetas de temporada",
      "Talleres de arte y expresión sensorial",
      "Juego libre y exploración",
      "Actividades al aire libre",
      "Cuentacuentos y música"
    ]
  },
  schedule: {
    title: "Fechas y Horarios",
    dates: "22 de diciembre de 2026 a 7 de enero de 2027",
    note: "(excepto festivos)",
    hours: "Horario: 9:00 - 14:00",
    extended: "Concilia: 8:30 - 15:30",
    ages: "Edades: 3 a 12 años"
  },
  prices: {
    title: "Precios",
    members: "Miembros Gándara",
    nonMembers: "No miembros",
    oneWeek: "1 Semana",
    complete: "Completo"
  },
  contact: {
    title: "¡Reserva tu plaza!",
    button: "Inscribirse"
  }
};

export const summerCamp = {
  title: "Campamento de Verano 2026",
  subtitle: "Únete a una experiencia inolvidable en el campamento de verano de Gándara International School",
  gallery: {
    title: "Galería",
    caption: "Momentos de nuestros campamentos de verano",
    images: [
      { src: "/lovable-uploads/86807e57-9b48-4117-811e-2178c1e55e7d.png", alt: "Niños jugando al aire libre" },
      { src: "/lovable-uploads/4fb227e3-a5f5-4a84-94b3-bdbd9ebd058b.png", alt: "Explorando la naturaleza" },
      { src: "/lovable-uploads/b8f5b9b1-cac2-4895-b283-d2a0df3dbed9.png", alt: "Actividades creativas" }
    ]
  },
  intro: "Este verano, en Gándara International School, abrimos las puertas a una experiencia inolvidable: un campamento único donde la naturaleza, el juego y el desarrollo emocional se entrelazan para ofrecer a cada niño y niña un verano lleno de magia, descubrimiento y crecimiento personal.",
  educationalProposal: {
    title: "Una propuesta educativa diferente",
    content: "En Gándara International School, creemos que un futuro brillante comienza con una infancia vivida con plenitud. Nuestro campamento no es solo un espacio de ocio, sino una experiencia educativa integral, en un entorno en el que los niños puedan:",
    items: [
      "Reconectar con la naturaleza y con su propio ritmo interior.",
      "Descubrir el mundo a través del juego, la emoción y la curiosidad.",
      "Sentirse escuchados, acompañados y respetados"
    ],
    additional: "Cada día es una oportunidad para crecer, imaginar, explorar, aprender y compartir. Este campamento nace del compromiso pedagógico de Gándara International School, integrando metodologías como:",
    methodologies: [
      "Educación en la naturaleza (bosquescuela y aprendizaje del inglés)",
      "Propuestas STEM para despertar el pensamiento lógico y científico",
      "Actividades de lectura, cuentos y escritura creativa para nutrir el lenguaje, la expresión y la imaginación"
    ],
    conclusion: "Una combinación que impulsa tanto el aprendizaje activo como el desarrollo emocional y social.",
    workshopsTitle: "Talleres temáticos semanales",
    workshops: [
      { day: "Lunes", activity: "Arte" },
      { day: "Martes", activity: "Manualidades" },
      { day: "Miércoles", activity: "Cocina" },
      { day: "Jueves", activity: "Experimentos y propuestas de los niños/as" },
      { day: "Viernes", activity: "Salidas" }
    ],
    workshopsNote: "Los talleres no son obligatorios y se podrán modificar en función de las participantes."
  },
  principles: {
    title: "Nuestros principios pedagógicos",
    list: [
      "Conexión con la naturaleza desde la experiencia directa",
      "Juego libre como base para el aprendizaje",
      "Acompañamiento individualizado y respetuoso",
      "Dinámicas que fomentan empatía, cooperación y autorregulación",
      "Actividades significativas para desarrollar la inteligencia práctica y emocional",
      "Espacios donde crecer con confianza, autonomía y alegría",
      "Fomentar la curiosidad científica y el pensamiento lógico a través de propuestas STEM adaptadas a cada etapa"
    ]
  },
  audience: {
    title: "¿A quién va dirigido?",
    ageGroups: "Niños y niñas de 3 a 12 años",
    ratio: "Ratio 1:14",
    note: "Trabajamos con grupos reducidos, garantizando una atención personalizada y un acompañamiento cercano."
  },
  location: {
    title: "Localización privilegiada",
    name: "Gándara International School",
    address: "Gondomar (Pontevedra)",
    description: "Un entorno rural natural, seguro y lleno de posibilidades:",
    features: [
      "Amplios jardines exteriores con piscina",
      "Salas polivalentes para talleres y actividades tranquilas",
      "Cocina, baños y zonas cubiertas adaptadas a la infancia y la climatología",
      "Huerta escolar activa durante todo el verano"
    ]
  },
  schedule: {
    title: "Fechas y horarios",
    dates: "Del 22 de junio al 4 de septiembre de 2026",
    days: "De lunes a viernes, en horario de mañana",
    holidays: "Festivos: 24 de junio (festivo autonómico) y 17 de agosto (festivo local)",
    timetable: {
      title: "Horario tipo:",
      slots: [
        { time: "09:00 - 10:00", activity: "Llegada flexible" },
        { time: "10:00 - 10:30", activity: "Círculo de la mañana: presentación del taller del día y tiempo para compartir" },
        { time: "10:30 - 11:30", activity: "Taller temático del día" },
        { time: "11:30 - 12:00", activity: "Merienda" },
        { time: "12:00 - 13:30", activity: "Juego libre, incluyendo piscina" },
        { time: "13:30 - 14:00", activity: "Recogida de material y despedida" },
        { time: "14:00 - 15:30", activity: "Comedor (tupper de casa)" }
      ]
    }
  },
  included: {
    title: "¿Qué incluye el campamento?",
    items: [
      "Talleres temáticos diarios (arte, manualidades, cocina, experimentos, salidas)",
      "Juego libre y tiempo de piscina",
      "Materiales didácticos y creativos",
      "Acompañamiento respetuoso por profesionales cualificados",
      "Seguro de responsabilidad civil y accidentes",
      "Posibilidad de servicio de comedor (con tupper de casa)",
      "Posibilidad de concilia: aula madruga y aula salida"
    ]
  },
  toBring: {
    title: "¿Qué deben llevar los niños?",
    items: [
      "Ropa cómoda y que se pueda manchar",
      "Mochila con botella de agua y merienda",
      "Gorra y protección solar",
      "Toalla y bañador (para la piscina)",
      "Muda de recambio",
      "Chubasquero (en caso de lluvia)"
    ],
    note: "Todo marcado con su nombre para evitar pérdidas."
  },
  registration: {
    cta: "Inscríbete ahora",
    title: "Inscripción",
    limitedSpots: "¡Plazas limitadas!",
    options: "Puedes inscribirte por semanas o por el verano completo.",
    form: {
      title: "Formulario de inscripción",
      parentInfo: "Información del padre/madre/tutor",
      childInfo: "Información del niño/a",
      weeksSelection: "Selección de semanas",
      options: "Opciones adicionales",
      membership: "Membresía de Gándara",
      submit: "Enviar inscripción"
    }
  },
  pricing: {
    title: "Precios",
    weeks: {
      oneWeek: "1 Semana",
      twoWeeks: "2 Semanas",
      threeWeeks: "3 Semanas",
      fourWeeks: "4 Semanas",
      fiveWeeks: "5 Semanas"
    },
    members: "Miembros de Gándara",
    nonMembers: "No miembros",
    options: {
      lunch: "Comedor (tupper de casa)",
      earlyDropoff: "Aula madruga",
      latePickup: "Aula salida"
    },
    labels: {
      daily: "Diario",
      weekly: "Semanal",
      monthly: "Mensual",
      perSection: "Por tramo"
    },
    discounts: {
      title: "Descuentos para hermanos",
      secondChild: "10% de descuento para el 2º hijo/a",
      thirdChild: "25% de descuento para el 3er hijo/a y siguientes"
    }
  },
  faq: {
    title: "Preguntas frecuentes",
    questions: [
      {
        question: "¿Qué edades pueden participar en el campamento?",
        answer: "Pueden participar niños y niñas de 3 a 12 años, con una ratio de 1:14."
      },
      {
        question: "¿Qué ocurre si mi hijo/a tiene restricciones alimentarias?",
        answer: "Por favor, indica cualquier alergia o restricción alimentaria en el formulario de inscripción y nos adaptaremos adecuadamente."
      },
      {
        question: "¿Cuál es la política de cancelación?",
        answer: "Las cancelaciones realizadas hasta dos semanas antes de la fecha de inicio reciben un reembolso completo. Las cancelaciones dentro de las dos semanas previas a la fecha de inicio reciben un reembolso del 50%. No hay reembolsos para cancelaciones dentro de las 72 horas previas a la fecha de inicio."
      },
      {
        question: "¿Los talleres son obligatorios?",
        answer: "No, los talleres no son obligatorios. Los niños pueden participar libremente y las actividades se pueden modificar en función de los participantes."
      }
    ]
  }
};

export const summerCampConfirmation = {
  title: "¡Inscripción Enviada!",
  subtitle: "Hemos recibido tu inscripción para el campamento de verano. Recibirás un email de confirmación en breve.",
  contactTitle: "¿Necesitas contactarnos?",
  contact: {
    phone: "Teléfono",
    email: "Email",
  },
  backToCamp: "Volver al campamento",
  backToHome: "Volver al inicio",
  note: "Si no recibes el email de confirmación, revisa tu carpeta de spam o contacta directamente con nosotros.",
};
